import moment from 'moment';
import { ApprovalCode } from '../components/Constants';

export function hasApproval(value) {
  return typeof value === 'string' && value.toLowerCase() === ApprovalCode.toLowerCase();
}

// Keep these rules in sync with backend/lib/animalReview.js.
export function texasReviewMessage(state, dob, now = new Date()) {
  if (state !== 'TX') return null;

  const birthDate = moment(dob, 'MM/DD/YYYY', true);
  // Use the same business date as the API, regardless of the browser's timezone.
  const today = moment(new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/Chicago', year: 'numeric', month: '2-digit', day: '2-digit',
  }).format(now), 'MM/DD/YYYY', true);

  if (!birthDate.isValid() || birthDate.isAfter(today, 'day')) {
    return 'Enter a valid date of birth.';
  }
  // Include the eight-month birthday, without rounding down to whole months.
  if (birthDate.add(8, 'months').isSameOrAfter(today, 'day')) {
    return 'For Texas cattle 8 months old or younger, call Jimmy James at 580-481-0955 for review and approval before binding coverage.';
  }
  return null;
}

export function animalReviewMessage(value, state, dob, now = new Date()) {
  if (hasApproval(value)) return null;
  const texasMessage = texasReviewMessage(state, dob, now);
  if (texasMessage) return texasMessage;
  if (typeof value === 'string' && /^[\d,]+$/.test(value) && Number(value.replace(/,/g, '')) > 30000) {
    return 'For any purchase price over $30,000, call Jimmy James at 580-481-0955 to bind coverage.';
  }
  return null;
}

export function validatePurchasePrice(value, state, dob, now = new Date()) {
  if (hasApproval(value)) return true;
  if (typeof value !== 'string' || !/^[\d,]+$/.test(value)) return 'Invalid price';
  return animalReviewMessage(value, state, dob, now) || true;
}
